import styled from 'styled-components';

export const SearchInputField = styled.div(
  props => `
       
.rangeFieldWpr input,
.singleInputWpr input {
  color: Theme.$secondaryText;
  font-size: 16px;
  width: 100%;
  outline: none;
  border-radius: 5px;
  border: 1px #e7e7e7 solid;
  //font-family: Theme.$globalFontFamily;
}

.singleInputWpr input::placeholder,
.rangeFieldWpr input::placeholder {
  font-size: 16px;
  line-height: 19px;
  color: Theme.$secondaryText;
  //font-family: Theme.$globalFontFamily;
}

// ---------- FOR SINGLE INPUT ----------
.singleInputWpr {
  position: relative;
}

.singleInputWpr .icon {
  position: absolute;
  bottom: 16px;
  left: 12px;
}

.singleInputWpr input {
  padding: 12.5px 12px 12px 40px;
}

// ---------- FOR RANGE INPUT ----------
.rangeFieldWpr {
  display: flex;
  align-items: center;
}

.rangeFieldWpr input {
  padding: 12px;
}

.rangeFieldWpr .separator {
  display: inline-block;
  width: 8px;
  height: 3px;
  margin: 0px 8px;
  background-color: #e7e7e7;
}

// ---------- INPUT FIELD TWO ----------
.inputFldTwo .inputWpr {
  display: flex;
  border-radius: 4px;
}

.inputFldTwo .inputWpr input {
  //font-family: Theme.$globalFontFamily;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  text-transform: uppercase;
  padding: 11px 12px;
  margin: 0px;
  outline: none;
  border: none;
  flex: 1;
  border-radius: 4px 0px 0px 4px;
  border: 1px solid #e4e4e4;
  border-right: none;
}

.inputFldTwo .inputWpr input.error {
  //.$redBg;
  border-right: none;
}

.inputFldTwo .inputWpr input::placeholder {
  //font-family: Theme.$globalFontFamily;
  text-transform: none;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #4a4a4a;
}

.inputFldTwo .inputWpr input::-webkit-input-placeholder {
  //font-family: Theme.$globalFontFamily;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #4a4a4a;
}

.inputFldTwo .inputWpr input:-ms-input-placeholder {
  //font-family: Theme.$globalFontFamily;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #4a4a4a;
}

.inputFldTwo .inputWpr input:focus {
  box-shadow: 0px 1px 7px rgba(0, 0, 0, 0.2);
  border: 1px solid transparent;
  border-right: 0;
}

.inputFldTwo .inputWpr input:focus + .btnWpr {
  border: 1px solid transparent;
  border-left: 0;
}

.inputFldTwo .inputWpr input.error:focus {
  box-shadow: none;
  //border: 1px solid Theme.$redBg;
  border-right: 0px;
}

.inputFldTwo .inputWpr .btnWpr {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  //background: Theme.$primaryColor;
  height: 44px;
  width: 44px;
  border-radius: 0 4px 4px 0;
  border: 1px solid #e4e4e4;
  border-left: none;
}

.inputFldTwo .inputWpr .btnWpr.error {
  //border: 1px solid Theme.$redBg;
  border-left: none;
}

.inputFldTwo .inputWpr input.error:focus + .btnWpr {
  //border: 1px solid Theme.$redBg;
  border-left: 0px;
}

// ---------- FORM INPUT FIELDS ----------
.formInpWpr {
  position: relative;
  display: inline-block;
}

.formInpWpr input {
  padding-left: 12px;
  padding-right: 12px;
  display: flex;
  width: 100%;
  height: 48px;
  font-size: 14px;
  line-height: 20px;
  //color: Theme.$secondaryText;
  ///font-family: Theme.$globalFontFamily;
  border-radius: 4px;
  border: 1px #e4e4e4 solid;
  outline: none;
}

.formInpWpr input::placeholder {
  font-size: 14px;
  line-height: 20px;
  //color: Theme.$secondaryText;
  //font-family: Theme.$globalFontFamily;
}

.formInpWpr .labelText,
.dropdownTrip .labelText,
.formDrpFldWpr .labelText {
  margin-bottom: 8px;
  font-size: 14px;
  line-height: 16px;
  font-weight: 900;
  //color: Theme.$secondaryText;
}
.formDrpFldWpr .disabled {
  //color: Theme.$secondaryText;
  background-color: Theme.$lightGreyBg;
}

.formInpWpr.rwPgInpField {
  width: 320px;
}

.rwPgMiniInpField {
  width: 264px;
}

.formInpWpr .dropsideWpr {
  position: relative;
  display: flex;
  align-items: stretch;
}

.formInpWpr .dropsideWpr .formInpDropside {
  position: relative;
  display: flex;
  flex-shrink: 0;
  // align-items: center;
}

.formInpWpr .dropsideWpr .formInpDropsideV2 {
  position: relative;
  display: flex;
  flex-shrink: 0;
  // align-items: center;
}

.formInpWpr .dropsideWpr .formInpDropside.typeOne.focus {
 // border: 1px Theme.$blueText solid;
  border-right: none;
}
.formInpWpr .dropsideWpr .formInpDropsideV2.typeOne.focus {
  //border: 1px Theme.$blueText solid;
  border-right: none;
}

.formInpWpr .dropsideWpr .formInpDropside.typeOne {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  padding-left: 12px;
  padding-right: 14px;
  // padding-right: 12px;
  border: 1px #e4e4e4 solid;
  border-radius: 4px 0px 0px 4px;
  border-right: none;
  // width: 100%;
  // height: 100%;
}

.formInpWpr .dropsideWpr .formInpDropsideV2.typeOne {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  padding-left: 12px;
  // padding-right: 12px;
  border: 1px #e4e4e4 solid;
  border-radius: 4px 0px 0px 4px;
  border-right: none;
  // width: 100%;
  // height: 100%;
}

.formInpWpr .dropsideWpr .formInpDropside label.focus {
  //border: 1px Theme.$blueText solid;
  border-right: none;
}

.formInpWpr .dropsideWpr .formInpDropsideV2 label.focus {
  //border: 1px Theme.$blueText solid;
  border-right: none;
}

.formInpWpr .dropsideWpr .formInpDropside label {
  // display: flex;
  flex-shrink: 0;
  padding-left: 12px;
  padding-right: 14px;
  // padding-right: 12px;
  overflow: hidden;
  border: 1px #e4e4e4 solid;
  border-radius: 4px 0px 0px 4px;
  border-right: none;
  // width: 100%;
  // height: 100%;
}

.formInpWpr .dropsideWpr .formInpDropsideV2 label {
  // display: flex;
  flex-shrink: 0;
  padding-left: 12px;
  padding-right: 14px;
  // padding-right: 12px;
  overflow: hidden;
  border: 1px #e4e4e4 solid;
  border-radius: 4px 0px 0px 4px;
  border-right: none;
  // width: 100%;
  // height: 100%;
}

// ---------- LITTLE CHEVRON ICON ----------
.formInpWpr .dropsideWpr .formInpDropside::after {
  content: '';
  position: absolute;
  top: 48%;
  transform: translateY(-50%) rotate(45deg);
  right: 0px;
  width: 6px;
  height: 6px;
  pointer-events: none;
  //border-right: 1px Theme.$secondaryText solid;
  //border-bottom: 1px Theme.$secondaryText solid;
}

.formInpWpr .formInpDropside .selectInfoCtr {
  // position: absolute;
  display: flex;
  height: 100%;
  // border-right: 1px red solid;
  align-items: center;
  pointer-events: none;
}

.formInpWpr .formInpDropsideV2 .selectInfoCtr {
  // position: absolute;
  display: flex;
  height: 100%;
  // border-right: 1px red solid;
  align-items: center;
  pointer-events: none;
}

.formInpWpr .formInpDropside .selectInfoCtr img {
  margin-right: 8px;
  width: 24px;
  flex-shrink: 0;
}
.formInpWpr .formInpDropsideV2 .selectInfoCtr img {
  margin-right: 8px;
  width: 24px;
  flex-shrink: 0;
}

.formInpWpr .formInpFld.sd1,
.formInpWpr .formInpFld.sd2 {
  // padding-left: 90px;
  // width: 100%;
  // flex: 1;
  // border: 1px red solid;
  border-left: none;
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}
.dropdownTrip{
  position: relative;
  display: inline-block;
}
.dropdownTrip input{
  padding-left: 40px;
  padding-right: 12px;
  display: flex;
  width: 100%;
  height: 48px;
  font-size: 14px;
  line-height: 20px;
  color: Theme.$secondaryText;
  font-family: Theme.$globalFontFamily;
  border-radius: 4px;
  border: 1px #e4e4e4 solid;
  outline: none;
} 
.dropdownTrip .dropsideWpr{
  position: relative;
  display: flex;
  align-items: stretch;
}

.dropdownTrip .fipRightIcon {
  position: absolute;
  top: 20px;
  right: 12px;
  pointer-events: none;
}

.dropsideWpr input{
  padding-left: 12px;
}

  

@mixin selectTagStyles {
  cursor: pointer;
  position: absolute;
  top: 0px;
  left: 0px;
  height: 100%;
  border: none;
  border-right: none;
  outline: none;
  color: transparent;
  background-color: transparent;
}

.formInpWpr .formInpDropside .sd1,
.formInpWpr .formInpDropside .sd2 {
  @include selectTagStyles;
  width: 100%;
}

.formInpWpr .formInpDropsideV2 .sd1,
.formInpWpr .formInpDropsideV2 .sd2 {
  @include selectTagStyles;
  width: 100%;
}

// BOTTOM_DROPDOWN
.formInpWpr .formInpDropdown {
  position: absolute;
  z-index: 10;
  width: 403px;
  top: 78px;
  left: 0px;
  max-height: 196px;
  overflow-y: scroll;
  border-radius: 4px;
  background-color: white;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.06);
}

.formInpWpr .suggestionsCtr {
  position: absolute;
  position: absolute;
  top: 78px;
  width: 100%;
  z-index: 10;
  border-radius: 4px;
  background-color: white;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.06);
}

.formInpWpr .suggestionsCtr > li {
  padding: 10px 12px;
  cursor: pointer;
}

.formInpWpr .suggestionsCtr > li:hover {
  //background-color: Theme.$secondaryColor;
}

.formInpWpr .formInpDropdown > li {
  display: flex;
  padding: 16px 12px;
}

.formInpWpr .fipRightIcon {
  position: absolute;
  top: 42px;
  right: 12px;
  pointer-events: none;
}

.formInpWpr .formInpDropdown > li.active,
.formInpWpr .formInpDropdown.typeTwo > li.active {
  color: white;
  font-weight: 900;
 // background-color: Theme.$primaryColor;
}

.formInpWpr .formInpDropdown > li:not(.active):not(.loadingPt):hover {
 // background-color: Theme.$secondaryColor;
}

// .formInpWpr .formInpDropdown > li:first-child {
//     padding-top: 24px;
// }

// .formInpWpr .formInpDropdown > li:last-child {
//     padding-bottom: 24px;
// }

.formInpWpr .formInpDropdown > li:not(:last-child),
.formInpWpr .suggestionsCtr > li:not(:last-child) {
  border-bottom: 1px #e3e3e3 solid;
}

// BOTTOM_DROPDOWN_2
.formInpWpr .formInpDropdown.typeTwo {
  width: 100%;
  max-height: 144px;
  overflow-y: scroll;
}

.formInpWpr .formInpDropdown.typeTwo > li {
  cursor: pointer;
  display: flex;
  padding: 16px 12px;
}

.formInpWpr .formInpDropdown.typeTwo > li:not(.active):hover {
  font-weight: 900;
  //background-color: Theme.$secondaryColor;
}

.formInpWpr .formInpDropdown::-webkit-scrollbar {
  width: 5px;
}

.formInpWpr .formInpDropdown::-webkit-scrollbar-thumb {
  border: 0;
  border-radius: 4px;
  background-color: #949494;
}

.formInpWpr .formInpDropdown::-webkit-scrollbar-track {
  background-color: #f2f2f2;
  border-radius: 0px 4px 4px 0px;
}

// ---------- FORM INPUT STATES ----------
.formInpWpr input:focus {
 // border: 1px Theme.$orangeText solid;
}

.formInpWpr input.scs {
  //border: 1px Theme.$darkGreenBg solid;
}

.formInpWpr .dropsideWpr .formInpDropside label.scs {
  border: 1px Theme.$darkGreenBg solid;
  border-right: none;
}

.formInpWpr .dropsideWpr .formInpDropside label.err {
  //border: 1px Theme.$redBg solid;
  border-right: none;
}

// .formInpWpr input.scs:focus {
//     outline: 1px Theme.$blueText solid;
// }

.formInpWpr input.err {
  //border: 1px Theme.$redBg solid;
}

.formInpWpr input:disabled {
  //background-color: Theme.$lightGreyBg;
}

// .formInpWpr input.err:focus {
//     outline: 1px Theme.$blueText solid;
// }

// ---------- FOR THE DROPDOWNS ----------
.formDrpFldWpr {
  display: flex;
  flex-direction: column;
}

.formDrpFld {
  display: flex;
  align-items: center;
  border-radius: 4px;
  width: max-content;
  // border: 1px #E4E4E4 solid;
}

.formDrpFld .formDdOptnsCtr {
  position: absolute;
  top: 51px;
  height: 150px;
  overflow-y: scroll;
  left: 0px;
  width: 100%;
  z-index: 10;
  background-color: white;
  border-radius: 4px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.06);
}

.formDrpFld .formDdOptnsCtr > li {
  padding: 8px 10px;
}

.formDrpFld .formDdOptnsCtr > li:hover {
 // background-color: Theme.$secondaryColor;
}

.formDrpFld > div.active {
 // border: 1px Theme.$blueText solid;
}

.formDrpFld > div {
  position: relative;
  cursor: pointer;
  padding: 16px;
  display: flex;
  width: 96px;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  line-height: 20px;
  border: 1px #e4e4e4 solid;
}

.formDrpFld > div:first-child {
  border-radius: 4px 0px 0px 4px;
  // border-right: 1px #E4E4E4 solid;
}

.formDrpFld > div:last-child {
  border-radius: 0px 4px 4px 0px;
  border-right: 1px #e4e4e4 solid;
}

.formDrpFld > div:last-child.active {
  //border: 1px Theme.$blueText solid;
}

.cityFormDropdownList{
    position: absolute;
    background: #FFFFFF;
    border: 1px solid #D8D8D8;
    border-radius: 4px;
    top: 74px;
    left: 0;
    width: 175px;
    z-index: 2;
    max-height: 140px;
    overflow: scroll;
}

.cityFormDropdownListItem{
  padding: 10px;
  font-size: 14px;
  line-height: 18px;
}

.cityFormDropdownListItem:not(:last-child){
  border-bottom: 1px solid #D8D8D8;
}

// ANIMATED LABEL INPUT FIELD
.animatedLblFld {
  position: relative;
  width: 100%;
  height: 100%;
}

.animatedLblFld input {
  position: absolute;
  padding-left: 12px;
  padding-top: 14px;
  width: 100%;
  height: 100%;
  background-color: #f7f7f7;
  border: 1px #e7e7e7 solid;
  border-radius: 2px;
}

.animatedLblFld label {
  position: absolute;
  z-index: 2;
  top: 50%;
  left: 12px;
  transform: translateY(-50%);
  //color: Theme.$secondaryText;
  transition: 0.2s all;
}

// FOCUSED CASES
.animatedLblFld input:focus {
  //border: 0.5px Theme.$primaryColor solid;
  //outline: 0.5px Theme.$primaryColor solid;
}

.animatedLblFld label.focus {
  top: 5%;
  transform: translateY(0%);
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
  //color: Theme.$tertiaryText;
}

// DISABLED CASES
.animatedLblFld label.disable {
  color: rgba(0, 0, 0, 0.3);
}

.animatedLblFld input:disabled {
  border: 0.5px #d8d8d8 solid;
  outline: 0.5px #d8d8d8 solid;
  background-color: #ffffff;
}

// ERROR CASES
.animatedLblFld label.error {
  //color: Theme.$redText;
}

.animatedLblFld input.error {
  //border: 0.5px Theme.$redText solid;
  //outline: 0.5px Theme.$redText solid;
  //background-color: Theme.$lightRedBg;
}

// WIDTH HEIGHT USE-CASE
.animatedLblFld.typeOne {
  width: 148px;
  height: 48px;
}

.inputFldTextArea {
  textarea {
    background: #ffffff;
    border: 1px solid #e4e4e4;
    border-radius: 4px;
    padding: 12px;
    width: 100%;
    resize: none;
  }

  textarea:focus,textarea:focus-visible{
     outline: none !important;
    //border: 1px Theme.$blueText solid;
  }
  label {
    font-weight: 900;
    font-size: 14px;
    line-height: 16px;
    display: inline-block;
  }
}

//AIS Input

.addFlightInput{
  width: 370px;
}

.addTimeInput{
  width: 232px;
}

.flightNoInput{
  width: 200px;
}

    `,
);

export const TitleWrapper = styled.div(
  props => `
          //width:9.5rem;
          position: relative;
          flex-direction: row;
          display: flex
          align-items: center;
      `,
);

export const InputHorizontalWrapper = styled.div(
  props => `
    display: flex;
    align-items: center;
    width: ${props.isLabel ? '100%' : '20%'};
    //margin-bottom : 40px;
  `,
);

export const FileUploadderHorizontalWrapper = styled.div(
  props => `
    display: flex;
    align-items: center;
    width: 100%;
    margin-bottom : 40px;
  `,
);

export const InputBox = styled.input(
  props => `
    padding-left: 12px;
    padding-right: 12px;
    display: flex;
    width: 100%;
    height: 42px;
    font-size: 14px;
    line-height: 20px;
    color: #4A4A4A;
    font-family: "lato", sans-serif;
    border-radius: 4px;
    border: 1px #e4e4e4 solid;
    outline: none;
  `,
);

export const InputLabelHorizontal = styled.label(
  props => `
    width: 230px;
    flex-shrink: 0;
    margin-right: 30px;
    font-size: 14px;
    font-weight: 900;
    color: #4a4a4a;
  `,
);

export const LabelHorizontal = styled.label(
  props => `
    white-space: pre;
    font-size: 16px;
    color: #000;
    font-weight: bold;
    display: flex;
    line-height: 19px;
    margin-right: 80px;
  `,
);

export const CommonLabel = styled.label(
  props => `
        font-size: 16px;
        color: #000;
        font-weight: bold;
        display: flex;
        margin-bottom: 10px;
        line-height: 19px;
    `,
);

export const CommonInputWrap = styled.div(
  props => `
          width:100%;
          display: flex;
          flex-direction: column;
          position: relative;
    `,
);

export const CommonSelect = styled.select(
  props => `
    width: 100%;
    height: 4.2rem;
    background-color: ${props.theme.colors.white.base};
    display: flex;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    padding: ${props.theme.spacing.small.s5} ${props.theme.spacing.large.l30} ${
    props.theme.spacing.small.s5
  } ${props.theme.spacing.base};
    border: 1px solid ${props.theme.colors.grey.lightd0};
    background-color: ${props.theme.colors.white.base};
    border-radius: ${props.theme.misc.borderRadius.small};
    font-size: ${props.theme.font.large.font14};
    color: ${props.theme.colors.grey.base};
    font-weight: ${props.theme.font.fontWeight.bold};
    background-image: url('https://assets-gos3.goibibo.com/downarrow-1587111682.png');
    background-repeat: no-repeat;
    background-position: 95% 50%;
    background-size: 1.1rem auto;
    cursor: pointer;
    ::-ms-expand {
      display: none;
    }
  
    @media only screen and (min-width: 320px) and (max-width: 991px) {
      margin-bottom: ${props.theme.spacing.base};
      font-size: ${props.theme.font.large.font14};
    }
    border-color: ${props.hasError ? props.theme.colors.red.base : ''};
`,
);

export const FormWrapper = styled.div`
  .formRow {
    display: flex;
    //padding: 24px;
  }
  .primaryText {
    font-size: 26px;
    line-height: 32px;
    color: #000;
    font-weight: 900;
  }
  .secondaryText {
    font-size: 18px;
    line-height: 28px;
    color: #000;
  }
  .footerCtaWrapper {
    display: flex;
    gap: 12px;
    justify-content: flex-end;
    align-items: center;
  }
`;
